<div class="modal" [class.is-active]="show" *ngIf="_drug">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <span class="icon"><i class="fa fa-dna"></i></span>
        CanceRx information for {{ _drug.name }}
      </p>
      <button (click)="close()" class="delete" aria-label="close"></button>
    </header>
    <section class="modal-card-body">
      <p-table #datatable [value]="cancernetData" [autoLayout]="true" [filterDelay]="0" [globalFilterFields]="['approvedRegion','cancerType','target','cancerTypeLong']">
        <ng-template pTemplate="caption">
          <div style="text-align: right">
            <i class="pi pi-search" style="margin: 4px 4px 0 0"></i>
            <input
              type="text"
              pInputText
              size="50"
              placeholder="Search..."
              style="width: auto"
              (input)="datatable.filterGlobal($event.target.value, 'contains')"
            />
          </div>
        </ng-template>  
        <ng-template pTemplate="header">
          <tr>
            <th [pSortableColumn]="'approvedRegion'">
              Region
              <p-sortIcon [field]="'approvedRegion'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'cancerType'">
              Cancer Type
              <p-sortIcon [field]="'cancerType'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'targeted'">
              Targeted Therapy
              <p-sortIcon [field]="'targeted'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'target'">
              Target
              <p-sortIcon [field]="'target'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'cancerTypeLong'">
              Cancer Details
              <p-sortIcon [field]="'cancerTypeLong'"></p-sortIcon>
            </th>
            <!-- <th [pSortableColumn]="'notes'">
                    Notes
                    <p-sortIcon [field]="'notes'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'combinationFormation'">
                    Combination
                    <p-sortIcon [field]="'combinationFormation'"></p-sortIcon>
                </th> -->
            <th [pSortableColumn]="'link'">
              Link
              <p-sortIcon [field]="'link'"></p-sortIcon>
            </th>
            <!-- <th [pSortableColumn]="'accessDate'">
                    Accessed
                    <p-sortIcon [field]="'accessDate'"></p-sortIcon>
                </th> -->
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-e>
          <tr>
            <td>
              {{ e.approvedRegion }}
              <img
                *ngIf="e.approvedRegion === 'NIH'"
                class="image inline-flag"
                src="assets/usa_flag_32px.png"
                alt="USA flag"
                title="USA flag"
              />
              <img
                *ngIf="e.approvedRegion === 'UK'"
                class="image inline-flag"
                src="assets/uk_flag_32px.png"
                alt="UK flag"
                title="UK flag"
              />
            </td>
            <td>
              <p *ngIf="e.cancerType !== 'nan'">{{ e.cancerType }}</p>
              <p *ngIf="e.cancerType === 'nan'">-</p>
            </td>
            <td>
              <i *ngIf="e.targeted" class="fa fa-check has-text-primary"></i>
              <i *ngIf="!e.targeted" class="fa fa-times"></i>
            </td>
            <td>
              <p *ngIf="e.target !== 'nan'">{{ e.target }}</p>
              <p *ngIf="e.target === 'nan'">-</p>
            </td>
            <td>
              <p *ngIf="e.cancerTypeLong !== 'nan'" class="cancer-type-long">
                {{ e.cancerTypeLong }}
              </p>
              <p *ngIf="e.cancerTypeLong === 'nan'" class="cancer-type-long">
                -
              </p>
            </td>
            <!-- <td>{{ e.notes }}</td>
                <td>{{ e.combinationFormation }}</td> -->
            <td>
              <a href="{{ e.link }}" target="_blank"
                ><i class="fa fa-link"></i
              ></a>
            </td>
            <!-- <td>{{ e.accessDate }}</td> -->
          </tr>
        </ng-template>
      </p-table>
    </section>

    <footer class="modal-card-foot">
      <button
        (click)="close()"
        class="button"
      >
        Close
      </button>
    </footer>
  </div>
</div>
